<script>
    import { checkbox } from 'vue-strap';

    export default {
        components: { checkbox },
        props: {
            solicitacao: {
                required: true,
                type: Object,
            },
        },
        data() {
            return {
                configuracao: this.$storage.configuracao(),
                usuario: this.$storage.usuario(),
            }
        },
        methods: {
            removeErro(field) {
                var pos = -1;

                while (this.errors.has(field)) {
                    for (var i = 0; i < this.errors.items.length; i++) {
                        if (this.errors.items[i].field == field) {
                            pos = i
                            break
                        }
                    }

                    if (pos > -1) {
                        this.errors.items.splice(pos, 1)
                    }
                }
            },
            removeErroAceite() {
                this.removeErro('aceite');
            },
            adicionaErroAceite() {
                if (!this.errors.has('aceite')) {
                    this.errors.items.push(
                      { "id": "_y980569955l9f3565sd", "field": "aceite", "msg": "É obrigatório aceitar o termo de consentimento", "rule": "required", "scope": null }
                    )
                }
            },
        },
        watch: {
            'solicitacao.aceite': 'removeErroAceite',
        }
    }
</script>

<template>
    <div>
        <div class="row">
            <div class="col-xs-12">
                <div style="font-size: 18px;">
                    <span style="text-decoration: underline;"><strong>INFORMAÇÃO RELEVANTE</strong></span><br /><br />
                    Anualmente, como parte dos
                    procedimentos de fiscalização, a Fundação deve apresentar ao Tribunal de Contas
                    do Estado de São Paulo – TCE/SP, uma relação com todos os pagamentos realizados
                    a beneficiários pessoas físicas, nas modalidades: autônomo, adicional de
                    inovação e bolsistas. O objetivo do órgão é realizar o cruzamento dessas
                    informações com a base de dados do governo. Ao informar que o(a) beneficiário(a)
                    não é um <span style="text-decoration: underline;">funcionário público</span>, <span style="text-decoration: underline;">estou ciente</span> que a inexatidão dessa
                    informação, poderá acarretar notificações à Fundação e a coordenação do
                    projeto, solicitando esclarecimentos sobre a divergência dos dados fornecidos.
                    <br /><br />
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <div class="form-group required" :class="{'has-error': errors.has('aceite')}">
                    <div class="checkbox">
                        <checkbox v-model="solicitacao.aceite" value="1" type="primary">
                            Li e aceito o termo acima
                        </checkbox>
                    </div>

                    <p class="text-danger" v-show="errors.has('aceite')">{{ errors.first('aceite') }}</p>
                </div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-pagamento/fisica/componentes/compartilhado/FormTermo.vue